import React, { Fragment, useState } from "react";

import { Modal } from "../Modal/Modal.component";

import {
  Link,
  LinkContainer,
  TermsContainer,
  TermsTitle,
  TitleDescriptive,
  TextDescriptive,
} from "./Terms.styles";
import { useGetLegalTerm } from "./services/terms.actions";

export interface TermsProps {
  type?: "normal" | "descriptive";
}

export const Terms: React.FC<TermsProps> = ({ type = "normal" }) => {
  const [openModal, setOpenModal] = useState({
    open: false,
    term: "",
    title: "",
  });

  const { data, error, loading } = useGetLegalTerm();

  const handleModal = (term: "useTerms" | "privacyPolicies") => () => {
    if (data) {
      setOpenModal({
        open: true,
        term: data?.[term]?.text,
        title: data?.[term]?.name,
      });
    }
  };

  const closeModal = () => setOpenModal({ open: false, term: "", title: "" });

  return (
    <LinkContainer>
      {type === "normal" ? (
        <Fragment>
          <Link onClick={handleModal("useTerms")}>Termos de uso</Link>
          <Link onClick={handleModal("privacyPolicies")}>
            Política de privacidade
          </Link>
        </Fragment>
      ) : (
        <Fragment>
          <TitleDescriptive>
            Termos de uso e política de privacidade
          </TitleDescriptive>
          <TextDescriptive>
            Ao clicar em continuar você estará aceitando nossos{" "}
            <Link onClick={handleModal("useTerms")}>Termos de uso</Link> e{" "}
            <Link onClick={handleModal("privacyPolicies")}>
              Política de privacidade
            </Link>
          </TextDescriptive>
        </Fragment>
      )}
      <Modal open={openModal.open} handleClose={closeModal}>
        <TermsTitle>{openModal.title}</TermsTitle>
        <TermsContainer>{openModal.term}</TermsContainer>
      </Modal>
    </LinkContainer>
  );
};
